// extracted by mini-css-extract-plugin
module.exports = {"lcpweb":"lcpimage_lcpweb__K5z_c","lcpmob":"lcpimage_lcpmob__hhoUF"};